<template>
    <div id="test" style="user-select: none;">
        <!-- border: 'none', -->
        <div class="list" ref="imageWrapper" :style="{
         transform: 'scale(' + num + ')',
         position: 'relative',
         width: '300px',
         height: '300px',
       }" @mousedown="moveMouse">
            <div class="list1" v-drag :ref="'biaozhu' + index" @mousedown.stop="move($event,index)" @click="handelClick(index)" v-for="(item, index) in formData.injectionPosition" :key="index" :style="{
           width: item.width + 'px',
           height: item.height + 'px',
           position: 'absolute',
           left: item.left + 'px',
           top: item.top + 'px',
           background: 'rgba(43,100,206,0.3)',

         }">
                <el-button type="danger" class="del" v-if="index == divindex" @click="del(index,$event)" icon="el-icon-delete" style="padding:1px;"></el-button>
            </div>
            <div class="list2" :style="{
           height: biaozhuHeight + 'px',
           width: biaozhuWidth + 'px',
           top: biaozhuTop + 'px',
           left: biaozhuLeft + 'px',
           position: 'absolute',
           background: 'rgba(43,100,206,0.3)',
         }"></div>
            <img style="width:300px; height:300px; pointer-events: none;" src="../../assets/img/people.png" alt="" />
        </div>
    </div>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
    props: ['formData'],
    data() {
        return {
            num: 1,
            width: "",
            height: "",
            left: "",
            top: "",
            biaozhuHeight: 0,
            biaozhuWidth: 0,
            biaozhuTop: 0,
            biaozhuLeft: 0,
            divindex: -1,
            divList: ''
        };
    },
    methods: {
        moveMouse(e) {
            let odiv = e.target; //获取目标元素
            let disX = e.clientX;
            let disY = e.clientY;
            document.onmousemove = (e) => {
                //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                // console.log(e);
                let left = disX - odiv.getBoundingClientRect().x;
                let top = disY - odiv.getBoundingClientRect().y;
                this.width = (e.clientX - disX) / this.num;
                this.height = (e.clientY - disY) / this.num;
                // console.log(this.width, this.height);
                this.biaozhuWidth = this.width;
                this.biaozhuHeight = this.height;
                this.biaozhuLeft = left;
                this.biaozhuTop = top;
                document.onmouseup = (e) => {
                    // console.log(odiv.getBoundingClientRect().x, odiv.getBoundingClientRect().y);
                    // console.log(left, top);
                    // console.log(e.target.getBoundingClientRect(), disX, disY);
                    if (this.width > 5 && this.height > 5) {
                        this.formData.injectionPosition.push({
                            width: 50,
                            height: 30,
                            left: left,
                            top: top,
                        });
                        this.$forceUpdate()
                    }
                    this.biaozhuWidth = 0;
                    this.biaozhuHeight = 0;
                    this.biaozhuLeft = 0;
                    this.biaozhuTop = 0;
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
            }
        },
        move(e, i) {
            // console.log('111');
            this.divindex = i
            // console.log('当前移动下标' + i);
            this.divList = e.target; //获取目标元素
            document.addEventListener("mousemove", this.stagesContainerGrabMouseMoveHandler, );
            document.addEventListener("mouseup", this.stagesContainerGrabMouseUpHandler, )
        },
        stagesContainerGrabMouseMoveHandler(e) {
            // console.log(this.divList.style.left, this.divList.style.top);
            //移动当前元素
            this.formData.injectionPosition[this.divindex].left = Number(this.divList.style.left.replace('px', ''));
            this.formData.injectionPosition[this.divindex].top = Number(this.divList.style.top.replace('px', ''));
        },

        stagesContainerGrabMouseUpHandler(e) {
            // console.log(odiv.style.left, odiv.style.top);
            document.removeEventListener("mousemove", this.stagesContainerGrabMouseMoveHandler);
            document.removeEventListener("mouseup", this.stagesContainerGrabMouseUpHandler);
        },

        handelClick(i) {
            this.divindex = i
            // console.log(i);
        },
        //删除当前div
        del(i, e) {
            this.formData.injectionPosition.splice(i, 1);
            if (i == this.formData.injectionPosition.length) {
                this.divindex = -1;
            }
            e.stopPropagation();
            this.$emit('boxSon', this.formData.injectionPosition);
        },
        //div上拉伸的阻止冒泡事件
        sacle(e) {
            e.stopPropagation();
        },
    },
    directives: {
        drag: function (el) {
            let dragBox = el; //获取当前元素
            dragBox.onmousedown = (e) => {
                //算出鼠标相对元素的位置
                let disX = e.clientX - dragBox.offsetLeft;
                let disY = e.clientY - dragBox.offsetTop;
                // console.log(disX, disY);
                document.onmousemove = (e) => {
                    //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                    let left = e.clientX - disX;
                    let top = e.clientY - disY;
                    if (left < 0) {
                        left = 0;
                    }
                    if (top < 0) {
                        top = 0;
                    }
                    if (left > 300 - el.offsetWidth) {
                        left = 300 - el.offsetWidth;
                    }
                    if (top > 300 - el.offsetHeight) {
                        top = 300 - el.offsetHeight;
                    }
                    // console.log(left, top);
                    dragBox.style.left = left + 'px';
                    dragBox.style.top = top + 'px';
                };
                document.onmouseup = (e) => {
                    //鼠标弹起来的时候不再移动
                    document.onmousemove = null;
                    //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）
                    document.onmouseup = null;
                };
            };
        },
    },
};
</script>
<style >
/* .list {
  border: 1px solid red;
  margin: 0 auto;
}
.list1 {
  border: 1px solid green;
}
.list2 {
  border: 1px solid yellow;
} */
</style>
